<div class="shell-container fade-background">
    <div class="gradient"></div>
    <div class="page-content">
        <div class="header-logo-container">
            <img id="header-logo-image" [src]="kycPageCustomLogo" alt="" />
        </div>
        <router-outlet (activate)="routeActivate()"></router-outlet>
    </div>
</div>
<app-shared-footer [showTranslationAssistanceLink]="shellConfig?.showTranslationAssistanceLink"></app-shared-footer>
